import {ApiModules, ApiOperations} from "@qid/core";

export class PermissionUtil {

  static PermissionName(module: ApiModules, operation: ApiOperations | string) {
    return `${module}_${operation}`
  }

}
